import { Component, OnInit, Output, Input, EventEmitter } from '@angular/core';
import { CourseViewModel } from 'src/app/_models/generatedModels';
import { AuthenticationService } from 'src/app/_services/authentication.service';

@Component({
  selector: 'bxl-course-materials',
  templateUrl: 'course-materials.component.html',
})
export class CourseMaterialsComponent implements OnInit {
  initialized = false;
  @Output()
  closed = new EventEmitter();

  @Input() course: CourseViewModel;
  constructor(public auth: AuthenticationService) {}

  ngOnInit(): void {
    this.initialized = true;
  }

  close() {
    console.log('close');
    this.closed.emit();
  }
}
